<!--
 * @Description: 个人信息-账户设置页面
 * @Author: laoliu,wanqian,sunhuihong
 * @Date: 2021-04-19 10:43:52
 * @LastEditTime: 2022-11-08 13:22:38
-->
<template>
  <div class="accountsetting-body">
    <el-row style="margin: 27px 0 10px 0; text-align: left">
      <span class="vertical-bar"></span><span>账户信息</span>
    </el-row>
    <el-row class="info-line">
      <img class="info-icon" src='@/assets/personal/icon-personal-username.png' alt=""/>
      <span class="info-title">账户名</span>
      <span class="info-value">{{curAdmin.name}}</span>
    </el-row>
    <el-row class="info-line">
      <img class="info-icon" src='@/assets/personal/icon-personal-password.png' alt=""/>
      <span class="info-title">账户密码</span>
      <span class="info-value">******</span>
      <el-button style="width: 100px; line-height: 0.6; background: #3E7EF5;" type="primary"
        @click="handleChangePassword">修 改</el-button>
    </el-row>
    <el-row class="info-line">
      <img class="info-icon" src='@/assets/personal/icon-personal-photo.png' alt=""/>
      <span class="info-title">用户头像</span>
      <span class="info-value" style="width: 550px">
        <el-upload class="upload-photo" :show-file-list="false" :auto-upload="false" accept="image/jpeg,image/png" 
          action="" :on-change="handleLogoChange">
          <el-image class="info-photo" :src="adminPhotoPath" :fit="!curAdmin || !curAdmin.photoPath ? 'contain' : 'cover'">
          </el-image>
          <span class="text">更换</span>
        </el-upload>
        <span style="font-size: 13px; color: #999999; margin-left: 15px;">
          请上传宽度不小于100像素的图片，图片大小不超过
          <span class="tip-red">2M</span>，支持上传<span class="tip-red">png、jpg、jpeg</span></span>
      </span>
    </el-row>
    
    <!-- 修改密码弹框 -->
    <change-password-dialog :visible="showDialog" @close-dialog="closeDialog"/>
  </div>
</template>

<script>
import Constant from '@/global/Constant.js'
import changePwdDialog from "./components/ChangePwdDialog.vue";
import headBus from '../pageframe/components/HeadBus.js'

export default {
  name: 'AccentSettings',
  components: { 
    'change-password-dialog': changePwdDialog
  },

  data() {
    return {
      curAdmin: {},
      showDialog: false,
    };
  },
  
  computed: {  
      adminPhotoPath: function () {  
        return !this.curAdmin.photoPath
          ? require('@/assets/personal/icon-personal-default-photo.png')
          : this.commonUtil.fillUrlArgments(this.commonUrl.URL_DOWNLOAD_FILE, this.curAdmin.photoPath);
      },
  },

  methods: {
    initData() {
      let adminType = sessionStorage.getItem(Constant.SESSION_ADMIN_TYPE);
      if (!adminType) adminType = 'global';

      let url = this.commonUtil.fillUrlArgments(Constant.URL_GET_CURRENT_ADMIN_INSTITUTION, adminType, 'true');
      this.appAxios("GET", url).then(result => {
        if (result != null) {
          this.curAdmin = result.data;
        }
      })
    },
    
    refreshHeader() {
      headBus.$emit('refreshHeaderAdminLogo', true);
    },

    handleChangePassword() {
      this.showDialog = true;
    },

    closeDialog() {
      this.showDialog = false;
    },
    
    handleLogoChange(file, _fileList) {
      let limitation = {
        maxSize: Constant.LIMIT_IMG_SIZE_2,
        maxWidth: 100.0,
        maxHeight: 0,
        extLimit: {
          limitType: 2,
					minRatio: 0.01,
					minRatioText: '100:1',
        },
        returnData: {}
      };
      this.imgUtil.validateAndCompressImg(file, limitation).then((data) => {
        if (data.errorText && data.errorText.length) {
          this.$message.error(data.errorText);
        } else {
          this.uploadIcon(data.file)
        }
      })
     },

    uploadIcon(file) {
      let formData = new FormData();
      formData.append('iconFile', file.raw);
      this.appAxios("PUT", Constant.URL_UPDATE_ICON, formData, this.commonConst.CNTYPE_FORM_DATA).then(result => {
        if (result != null) {
          this.curAdmin = result.data;
          this.refreshHeader();
        }
      })
    },
  },

  mounted() {
    this.$emit("breadcrumb", {text1: '个人中心', text2: '账户设置'});
    this.initData();
  }
}
</script>

<style>
.accountsetting-body .el-upload .el-image__inner {
  border-radius: 50%;
  width: 48px;
  height: 48px;
}
</style>
<style scoped>
.accountsetting-body {
  margin: 0;
  border: solid 0px;
}

.vertical-bar {
  width: 4px;
  height: 15px;
  margin-top: -2px; 
  margin-left: 40px; 
  margin-right: 8px;
  background: #3E7EF5;
  display: inline-block;
  vertical-align: middle;
}

.info-line {
  margin-left: 62px;
  padding-left: 10px;
  padding-top: 15px;
  padding-bottom: 15px;
  width: 860px;
  text-align: left;
  vertical-align: middle;
  border-bottom: 1px solid #EEEEEE;
}

.info-icon {
  margin-right: 24px;
  width: 40px;
  height: 40px;
  vertical-align: middle;
}

.info-title {
  width: 150px;
  display: inline-block;
  border: solid 0px red;
}

.info-value {
  width: 440px;
  display: inline-block;
  border: solid 0px red;
  color: #999999;
}

.upload-photo {
  display: inline-block;
  width: 48px;
  height: 48px;
  vertical-align: middle;
  cursor: pointer;
  border-radius: 24px;
}

.info-photo {
  position: relative;
  width: 48px;
  height: 48px;
  border-radius: 24px;
  vertical-align: middle;
  display: inline-block;
  z-index: 101;
}

.info-photo:hover {
  position: relative;
  background-color: lightgray;
  opacity: 0.4;
  z-index: 99;
}

.text {
  position: absolute;
  display: block;
  width: 48px;
  top: 30px;
  font-size: 14px;
  color:black;
  text-align: center;
  z-index: 100;
}

.tip-red {
  color: #FF1515;
}
</style>


// WEBPACK FOOTER //
// src/components/personal/AccountSettings.vue